// extracted by mini-css-extract-plugin
export default {"tabToolTip":"entitiesMaintenance_tabToolTip__U+kAU"};